import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['checkbox', 'text', 'submit'];

  connect() {
    this.update();
    this.checkboxTargets.forEach((el) => {
      el.dataset.action = 'change->all-checked#update';
    });
    this.textTargets.forEach((el) => {
      el.dataset.action = 'change->all-checked#update keyup->all-checked#update';
    });
  }

  allChecked() {
    return this.checkboxTargets.every((el) => el.checked);
  }

  allFilled() {
    return this.textTargets.every((el) => el.value);
  }

  update() {
    if (this.allChecked() && this.allFilled()) {
      this.submitTarget.removeAttribute('disabled');
    } else {
      this.submitTarget.setAttribute('disabled', 'disabled');
    }
  }
}